import React from 'react';
import { Navigate } from 'react-router-dom';
import { r } from './helpers';
import LandingPage from '../../pages/shared/LandingPage';
import RolePromptPage from '../../pages/shared/RolePromptPage';
import CompanyPickerPage from '../../pages/shared/CompanyPickerPage';
import PortalLoginPage from '../../pages/shared/PortalLoginPage';
import LegacyPortalRedirect, { RiderLegacyRedirect } from '../../components/LegacyPortalRedirect';
import { AdminDashboardPage } from '../lazyPages';

/** Apex domain: marketing landing + multi-tenant login paths. */
export function ApexPublicRoutes({ isAuthenticated, getDefaultRoute }) {
  const authRedirect = isAuthenticated ? <Navigate to={getDefaultRoute()} replace /> : null;

  return (
    <>
      {r('/', <LandingPage />)}
      {r('/login', authRedirect || <CompanyPickerPage />)}
      {r('/admin/login', authRedirect || <PortalLoginPage portal="admin" />)}
      {r('/:slug/login', authRedirect || <PortalLoginPage portal="company" />)}
      {r('/:slug/m/login', authRedirect || <PortalLoginPage portal="merchant" />)}
      {r('/:slug/rider/login', authRedirect || <PortalLoginPage portal="rider" />)}
    </>
  );
}

/** Company subdomain guest: role picker + legacy login redirects. */
export function CompanyGuestRoutes() {
  return (
    <>
      {r('/', <RolePromptPage />)}
      {r('/login', <PortalLoginPage portal="company" />)}
      {r('/m/login', <LegacyPortalRedirect portal="merchant" />)}
      {r('/rider/login', <LegacyPortalRedirect portal="rider" />)}
      {r('/rider_v2', <RiderLegacyRedirect />)}
      {r('/rider_v2/login', <RiderLegacyRedirect />)}
    </>
  );
}

/** Admin subdomain entry: / shows dashboard or login. */
export function AdminSubdomainEntry({ isAuthenticated }) {
  return (
    <>
      {r('/', isAuthenticated ? <AdminDashboardPage /> : <PortalLoginPage portal="admin" />)}
      {r('/login', <PortalLoginPage portal="admin" />)}
    </>
  );
}

/** Merchant subdomain guest login. */
export function MerchantSubdomainGuestRoutes() {
  return (
    <>
      {r('/', <PortalLoginPage portal="merchant" />)}
      {r('/login', <PortalLoginPage portal="merchant" />)}
      {r('/m/login', <Navigate to="/login" replace />)}
    </>
  );
}